import palette from '../../palette';

export default {
  input: {
    caretColor: palette.blueMain,
    padding: "10px 10px",
    fontSize: "15px",
    ['@media (max-width: 768px)']: {
      padding: "12px 16px",
      fontSize: "14px",
    },
  }
};
